<template>
    <div class="d-flex justify-content-center">
        
        <div class="d-flex flex-column justify-content-center main-stream windows-command-prompt">
            <div class="d-md-flex d-none flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/eggsgame.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center first-pharagraph my-5">
                <p>It's nighttime in a distant forest somewhere in the metaverse. 
                    Chickens have already laid their span <span style="color:#ffd723">$EGGS</span>, waiting for their owners to 
                    collect them. The owners have all the control in this metaverse. With their <span style="color:#ffd723">$EGGS</span>,
                    they not only play games to win huge prizes, but will be able to mint more chickens 
                    and snakes! After the genesis collection of 6000 NFTs, this will be the only way to mint more NFTs. 
                    However, their worst nightmares are right outside 
                    that coop door, waiting patiently for the opportunity to strike... </p><img class="d-none d-md-block" src="../assets/images/barn.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-md-start justify-content-center second-pharagraph position-relative my-5">
                <img class="d-none d-md-block" src="../assets/images/windmill.webp" alt="">
                <p>The snakes are merciless and relentless creatures, and they're after the chickens 
                    and the valuable <span style="color:#ffd723">$EGGS</span>. There is nothing stopping them (well, except roosters. but we’ll get to that). 
                    They'll kidnap chickens, steal their <span style="color:#ffd723">$EGGS</span> or even gamble for more. They visit every night to collect their
                    share of <span style="color:#ffd723">$EGGS</span> and if you feel lucky, you can choose ‘risky claim’, which is a double or nothing type deal 
                    chickens make with the snakes. Snakes might stuff their bellies with <span style="color:#ffd723">$EGGS</span>, but that doesn't satisfy their appetite
                    for malfeasance, so if they see an uncooped chicken(or snake?), they won't hesitate to kidnap it.</p>
            </div>
            <div class="d-flex flex-row justify-content-md-start justify-content-center third-pharagraph my-5">
                <p> That brings us to our guardian angels... the roosters. 
                    The bodyguard, the savior…- the heavy-. 
                    Roosters are there for one job and one job only, to protect
                    the coop from the evils of snakes...
                    in exchange for some <span style="color:#ffd723">$EGGS</span> of course, what?
                    you thought they'd do it for free... </p>
                    <img class="d-none d-md-block" src="../assets/images/roostervis.webp" alt="">
            </div>
             <div class="d-flex flex-row justify-content-md-start justify-content-center fourth-pharagraph my-5">
                <img class="d-none d-md-block" src="../assets/images/cark.webp" alt="">
                <p> One more thing! The owners meet up in the games room
                    every night to test their luck and win big prizes. 
                    Let's see if lady luck will be by your side! </p>
            </div>
             <div class="d-flex flex-row justify-content-md-start justify-content-center third-pharagraph my-5">
                <p> Eggs Game is a fully on-chain DeFi game that creates a whole new chapter in risk protocol games with the benefits of being on Polygon.
                    Having Polygon as a sandbox gives us the creative space to discover the true potential of a DeFi game with risk protocol without being
                    worried about the gas fees, and that's precisely what we did in the first phase of the game. We will introduce new mechanics and new utilizations for your precious <span style="color:#ffd723">$EGGS</span>, this is just the start of what we are bringing to the table.  </p>
                    <img class="d-none d-md-block mt-5" width="192px" height="192px" src="../assets/images/gifs/transparent-gifs/eggsport-t.gif" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/minting.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-md-center justify-content-start my-md-5 mx-5">
                <div class="d-flex flex-column justify-content-start mx-2">
                    <div class="d-flex flex-row justify-content-start gen-header">
                        GEN 0
                    </div>
                    <div class="d-flex flex-row justify-content-start gen-inside">
                        #1 to #6,000  - 120 MATIC
                    </div>
                </div>
                <div class="d-flex flex-column justify-content-start mx-md-5">
                    <div class="d-flex flex-row justify-content-start gen-header">
                        GEN 1
                    </div>
                    <div class="d-flex flex-row justify-content-start gen-inside">
                        #6,001 to #12,000 - 7,000 $EGGS
                    </div>
                    <div class="d-flex flex-row justify-content-start gen-inside">
                        #12,001 to #18,000 - 14,000 $EGGS
                    </div>
                    <div class="d-flex flex-row justify-content-start gen-inside">
                        #18,001 to #24,000 - 28,000 $EGGS
                    </div>
                     <div class="d-flex flex-row justify-content-start gen-inside">
                        #24,001 to #30,000 - 56,000 $EGGS
                     </div>
                </div>
                <div class="d-md-flex d-none flex-column justify-content-center mx-5">
                    <img width="164px" height="164px" src="../assets/images/gifs/transparent-gifs/minter-t.gif" alt="">
                </div>
            </div>
            <div class="d-flex flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/eggs.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph my-2">
                <p>
                    The max <span style="color:#ffd723">$EGGS</span> supply is 2,000,000,000 $EGGS 
                </p>
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph my-2">
                <p>
                    <span style="color:#ffd723">$EGGS</span> is an ERC-20 token and the currency of the farmers in this metaverse.
                It is earned through staking your NFTs and can be spent on minting new characters
                and gambling in the games room for a chance to win more.
                </p>
            </div>
            <div class="d-flex flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/basictavuktext.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph">
                <p>
                 <span style="color:#82fcc8">Minting ratio:</span>5/6 <br><br>
                <span style="color:#82fcc8">Enter Coop (Stake):</span> Chickens can lay 1,000 <span style="color:#ffd723">$EGGS</span>/day,and you can only unstake after
                laying 2,000 <span style="color:#ffd723">$EGGS</span>.<br><br>

                <span style="color:#82fcc8">Collect Eggs (Claim):</span> Chickens have to give 1/3 of their laid <span style="color:#ffd723">$EGGS</span>
                to snakes not to be their dinner.<br><br>

                <span style="color:#82fcc8">Risky Claim:</span> If you're feeling like a brave chicken,you can choose to hide from the snakes. 
                If you hide without being caught (%50): you pay no tax but if you get caught (%50): you pay 
                double the tax.<br><br>

                <span style="color:#82fcc8">Leave Coop (Unstake):</span> If chickens choose to leave the coop, they have a 50% chance of
                getting caught by the snakes and losing all their laid eggs and a 50% chance to
                make a swift exit and keep all their laid eggs.<br><br>
                </p>
            </div>
            <div class="d-flex flex-row justify-content-center">
                <img width="292px" height="292px" src="../assets/images/gifs/transparent-gifs/chicken-fall-t.gif" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center my-3">
                <img class="for-mobile" src="../assets/images/snake-basictext.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph my-1">
                <p>Snakes receive a venom rank between 5-8 upon mint — higher ranks 
                    receive a higher proportion of <span style="color:#ffd723">$EGGS</span> and stolen mints. <br><br>

                    <span style="color:#a669fc">Minting ratio:</span> 1/6 Enter cave (Stake): Snakes get 1/3 of <span style="color:#ffd723">$EGGS</span> laid
                    by chickens. They also kidnap 1/6 of newly minted chickens and snakes.<br><br>

                    <span style="color:#a669fc">Collect Eggs (Claim):</span> Snakes collect their fair share of the <span style="color:#ffd723">$EGGS</span>
                    acquired from chickens.<br><br>

                    <span style="color:#a669fc">Leave Cave (Unstake):</span> Leave the cave without losing any acquired <span style="color:#ffd723">$EGGS</span>.
                </p>
            </div>
            <div class="d-flex flex-row justify-content-center my-3">
                <img width="292px" height="292px" src="../assets/images/gifs/transparent-gifs/snake-alco-t.gif" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/rooster-text.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph my-1">
                <p>Roosters guard the incubator to prevent snakes from stealing newly minted NFTs.
                    They can guarantee protection for every 5 out of 6 mints. <br>
                    Every rooster is equal.<br><br>

                    <span style="color:#ff9bac">Minting ratio:</span> Roosters can only be minted on gen0, and there is only 30 <br><br>

                    <span style="color:#ff9bac">Guard (Stake):</span> Roosters get paid 1.5% of minting fees for their protection. <br><br>

                    <span style="color:#ff9bac">Collect Eggs (Claim):</span> Roosters collect their fair share of <span style="color:#ffd723">$EGGS</span> from minting commissions. <br><br>
                    
                    <span style="color:#ff9bac">Leave Lair (Unstake):</span> Leave the lair without losing any acquired <span style="color:#ffd723">$EGGS</span>.


                </p>
            </div>
            <div class="d-flex flex-row justify-content-center my-3">
                <img width="292px" height="292px" src="../assets/images/gifs/transparent-gifs/rooster-animation-t.gif" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/games-text.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph my-1">
                <p>Feeling lucky? Come on in to our Games Room, the hottest and the coolest place on the farm. 
                The owners meet at the Games Room to test their luck with their <span style="color:#ffd723">$EGGS</span>. Initially, there will
                be five games where you will have the chance to have some fun with your <span style="color:#ffd723">$EGGS</span>, gamble, and win 
                big prizes. The first game will be available right after gen0 mint is complete, and every
                game after that will be unlocked through surpassing minting milestones. <br><br> 

                Oh, I almost forgot, any <span style="color:#ffd723">$EGGS</span> holder is welcome in the Games Room...
                </p>
            </div>
            <div class="d-flex flex-row justify-content-center my-3">
                <img width="292px" height="292px" src="../assets/images/gifs/transparent-gifs/slot-animation-t.gif" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center my-5">
                <img class="for-mobile" src="../assets/images/notestext.webp" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center info-paragraph my-1">
                <p>Eggs Game has been designed to last for a long time. 
                    We are thinking long-term, and are committed to this game.
                    Every aspect of our eggconomy and utilization of <span style="color:#ffd723">$EGGS</span> has been
                    delicately put together by a group of highly talented economists. 
                    Also, the advantage of being on Polygon protocol gave us the freedom
                    we needed to explore more possibilities for smart contract-based
                    games  than we could ever imagine. <br><br>

                    Welcome to the farm; we hope you enjoy your stay. 
                    And watch out for the news on phase 2...
                </p>
            </div>
            <div class="d-flex flex-row justify-content-center my-3">
                <img width="292px" height="292px" src="../assets/images/gifs/transparent-gifs/chickensigara-t.gif" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'whitepaper',
    data(){
        return{

        }
    },
    beforeCreate(){
        document.body.className = 'whitepaper-background'
    },
    mounted(){
        document.body.className = 'whitepaper-background';
    },
    beforeDestroy(){
        document.body.className = ''
    }
}
</script>

<style scoped>
.return-button-bigger{
    background: none;
    text-decoration: none;
    color: #FFE574;
    border: 3px solid #FFE574;
    border-radius: 30px;
    font-size: 45px;
    padding: 0px 25px;
    line-height: 65px;
    margin-top: 75px;
    font-family: UpheavelPro;
}
.first-pharagraph p{
    width: 946px;
    color: white;
    font-size: 30px;
    text-align: left;
}
.info-paragraph p{
    width: 946px;
    color: white;
    font-size: 30px;
    text-align: left;
}
.main-stream{
    width: 1200px;
}
.second-pharagraph img{
    margin-right: -90px;
}
.second-pharagraph p{
    position: absolute;
    width: 992px;
    color: white;
    font-size: 30px;
    text-align: right;
    right: 0;
}
.third-pharagraph p{
    width: 946px;
    color: white;
    font-size: 30px;
    text-align: left;
}
.fourth-pharagraph p{
    margin-top: 40px;
    width: 946px;
    color: white;
    font-size: 30px;
    text-align: right;
}
.gen-header{
    font-size: 30px;
    color: #ffb623;
}
.gen-inside{
    font-size: 30px;
    color: #fff;
}
@media (max-width:770px) {
    .for-mobile{
        width: 40vh;
    }
    .first-pharagraph p,.second-pharagraph p, .third-pharagraph p, .fourth-pharagraph p{
        position: inherit;
        width:90%;
        text-align: center;
    }
    .main-stream{
        width: 100%;
    }
    .info-paragraph p{
        text-align: center;
    }
}
</style>